export type { Category, Fallacy, StorySlide, StoryTemplate } from "./types";
export { createStory } from "./types";
export { categories } from "./categories";
import { adHominem } from "./ad-hominem";
import { strawMan } from "./straw-man";
import { appealToAuthority } from "./appeal-to-authority";
import { redHerring } from "./red-herring";
import { slipperySlope } from "./slippery-slope";
import { falseDilemma } from "./false-dilemma";
import { bandwagon } from "./bandwagon";
import { tuQuoque } from "./tu-quoque";
import { circularReasoning } from "./circular-reasoning";
import { appealToEmotion } from "./appeal-to-emotion";
import { hastyGeneralization } from "./hasty-generalization";
import { appealToNature } from "./appeal-to-nature";
import { postHoc } from "./post-hoc";
import { whataboutism } from "./whataboutism";
import { noTrueScotsman } from "./no-true-scotsman";
import { argumentFromIgnorance } from "./argument-from-ignorance";
import { sunkCost } from "./sunk-cost";
import { appealToTradition } from "./appeal-to-tradition";
import { cherryPicking } from "./cherry-picking";
import { loadedQuestion } from "./loaded-question";
import { survivorshipBias } from "./survivorship-bias";
import { baseRateFallacy } from "./base-rate-fallacy";
import { gamblersFallacy } from "./gamblers-fallacy";
import { simpsonsParadox } from "./simpsons-paradox";
import { misleadingStatistics } from "./misleading-statistics";
import { samplingBias } from "./sampling-bias";
import { texasSharpshooter } from "./texas-sharpshooter";
import { ecologicalFallacy } from "./ecological-fallacy";
import { misleadingPercentages } from "./misleading-percentages";
import { anchoringBias } from "./anchoring-bias";
import { meanVsMedian } from "./mean-vs-median";
import { relativeVsAbsoluteRisk } from "./relative-vs-absolute-risk";
import { prisonersDilemma } from "./prisoners-dilemma";
import { zeroSumBias } from "./zero-sum-bias";
import { tragedyOfCommons } from "./tragedy-of-commons";
import { freeRider } from "./free-rider";
import { escalationTrap } from "./escalation-trap";
import { lossAversion } from "./loss-aversion";
import { dunningKruger } from "./dunning-kruger";
import { statusQuoBias } from "./status-quo-bias";
import { framingEffect } from "./framing-effect";
import { availabilityHeuristic } from "./availability-heuristic";
import { decoyEffect } from "./decoy-effect";
import { ikeaEffect } from "./ikea-effect";
import { normalcyBias } from "./normalcy-bias";
import { equivocation } from "./equivocation";
import { movingGoalposts } from "./moving-goalposts";
import { weaselWords } from "./weasel-words";
import { appealToComplexity } from "./appeal-to-complexity";
import { euphemismTreadmill } from "./euphemism-treadmill";
import { gishGallop } from "./gish-gallop";
import { falseBalance } from "./false-balance";
import { viralEqualsTrue } from "./viral-equals-true";
import { screenshotProof } from "./screenshot-proof";
import { engagementCredibility } from "./engagement-credibility";
import type { Fallacy } from "./types";

export const fallacies: Fallacy[] = [adHominem, strawMan, appealToAuthority, redHerring, slipperySlope, falseDilemma, bandwagon, tuQuoque, circularReasoning, appealToEmotion, hastyGeneralization, appealToNature, postHoc, whataboutism, noTrueScotsman, argumentFromIgnorance, sunkCost, appealToTradition, cherryPicking, loadedQuestion, survivorshipBias, baseRateFallacy, gamblersFallacy, simpsonsParadox, misleadingStatistics, samplingBias, texasSharpshooter, ecologicalFallacy, misleadingPercentages, anchoringBias, meanVsMedian, relativeVsAbsoluteRisk, prisonersDilemma, zeroSumBias, tragedyOfCommons, freeRider, escalationTrap, lossAversion, dunningKruger, statusQuoBias, framingEffect, availabilityHeuristic, decoyEffect, ikeaEffect, normalcyBias, equivocation, movingGoalposts, weaselWords, appealToComplexity, euphemismTreadmill, gishGallop, falseBalance, viralEqualsTrue, screenshotProof, engagementCredibility];
